import Parse from "parse";












export class TenantDomain extends Parse.Object {
  constructor(data) {
    super("APP_TenantDomain", data );
  }
}

Parse.Object.registerSubclass("APP_TenantDomain", TenantDomain);
